import { customElement, FASTElement, observable } from '@microsoft/fast-element';
import { Route } from '@microsoft/fast-router';
import { BuyerDashboardTemplate as template } from './buyer-dashboard.template';
import { BuyerDashboardStyles as styles } from './buyer-dashboard.styles';
import { logger } from '@genesislcap/foundation-comms';
import { RfqModal } from '../../components/modals/rfq-modal/rfq-modal';
import { CancelModal } from '../../components/modals/cancel-modal/cancel-modal';
import { WatchlistContainer } from '../../components/page-specific/buyer-dashboard-components/watchlist-container/watchlist';
import { IStructuredChatService } from '../../services/structured-chat.service';
import { IRfqService, INegotiationService, IVppaService } from '../../services';
import { IRfq, IVppa } from '../../types';
import { notifyError } from '../../utils/notify';
import { MarketPerformanceGraph } from '../../components/common/graph/market-performance-graph/market-performance-graph';
import { IExecutionService } from '../../services/execution.service';
import { NEGOTIATION_STATUS } from '../../utils';
import { IUserService } from '../../services/user.service';
import { IThirdPartyService } from '../../services/third-party.service';
import { MoreInfoModal } from '../../components/common/more-info/more-info-modal/more-info-modal';

const name = 'buyer-dashboard-route';

@customElement({
  name,
  template,
  styles,
})
export class BuyerDashboard extends FASTElement {
  @IUserService userService: IUserService;
  public rfqModal: RfqModal;
  public cancelModal: CancelModal;
  public moreInfoModal: MoreInfoModal;
  public watchlistElement: WatchlistContainer;
  @IRfqService rfqService: IRfqService;
  @IStructuredChatService structuredChatService: IStructuredChatService;
  @INegotiationService negotiationService: INegotiationService;
  @IVppaService vppaService: IVppaService;
  @IExecutionService executionService: IExecutionService;
  @IThirdPartyService thirdPartyService: IThirdPartyService;
  @observable isExpandedView: boolean = false;
  @observable selectedVppa: IVppa;
  @observable marketPerformanceGraph: MarketPerformanceGraph;
  constructor() {
    super();
    this.thirdPartyService.loadArteriaUrl();
  }

  public openRfqModal() {
    this.rfqModal.openModal(false, null);
  }

  public editRfq(data) {
    this.rfqModal.openModal(true, data.RFQ_ID, data.TICKER);
  }

  public copyRfq(data) {
    this.rfqModal.openModal(false, data.RFQ_ID, data.TICKER);
  }

  public openCancelModal(data) {
    this.cancelModal.openModal(data, 'RFQ', 'Are you sure you wish to cancel ' + data.TICKER + '?');
  }

  public isExpandedViewChanged() {
    if (this.marketPerformanceGraph) this.marketPerformanceGraph.reflow();
  }

  public cancelRfq(data: IRfq) {
    this.rfqService.eventRfqCancel(data.RFQ_ID, data.CONTRACT_TYPE).then(
      (response) => {
        if (response && response.MESSAGE_TYPE === 'EVENT_ACK') {
          this.cancelModal.closeDialog();
        } else {
          notifyError(response.ERROR[0].TEXT);
          logger.error(response.ERROR);
        }
      },
      (error) => {
        notifyError(error);
        logger.error(error);
      },
    );
  }

  public reviewProposal(data) {
    this.structuredChatService.openStructuredChat({
      selectedVPPAIDs: [],
      selectedRFQIDs: [],
      selectedNegotiationID: data.NEGOTIATION_ID,
    });
  }

  public clearRejected(data) {
    this.negotiationService.eventNegotiationClearReject(data.NEGOTIATION_ID);
  }
  public reviewAndClearRejected(data) {
    this.reviewProposal(data);
    this.clearRejected(data);
  }

  public favoriteSellerInterestVppa(data) {
    data.isClicked
      ? this.vppaService.eventInsertFavoritedVppa(data.VPPA_ID)
      : this.vppaService.eventDeleteFavoritedVppa(data.VPPA_ID);
  }

  public goToExecutionPage(data) {
    this.executionService.setNegotiationId(data.NEGOTIATION_ID);
    Route.path.push('execution');
  }

  public goToArteriaPage(data) {
    this.thirdPartyService.openArteriaNegotiations();
  }

  public goToArteriaNegotiationsPage(data) {
    if (data.NEGOTIATION_STATUS == NEGOTIATION_STATUS.EXECUTED) {
      this.thirdPartyService.openArteriaNegotiations();
      return;
    }
    //TODO select URL based on status and use transactionUUID instead of project?
    const projectUniqueIdentifier = data.PROJECT_UUID;
    if (projectUniqueIdentifier) {
      this.thirdPartyService.openArteriaChecklist(projectUniqueIdentifier);
    } else {
      this.thirdPartyService.openArteriaNegotiations();
    }
  }
  public getCurrentVppa(vppaId: string) {
    this.vppaService.getVppa(vppaId).then((result) => {
      this.selectedVppa = { ...result.REPLY[0] };
    });
  }

  public openMoreInfoModal(data) {
    this.moreInfoModal.openMoreInfoModal(data);
  }
}
